// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1MPC9","actionsCol":"EnrolledClinics_actionsCol__2wq0I"};